export default "__VITE_ASSET__QDtlOpUY__"